// src/components/invoice_terms/InvoiceDashboardAdminTermList.js
import React from "react";
import { useInvoiceData } from "../../../contexts/InvoiceDataContext";
import InvoiceTable from "./InvoiceTable";
import { columnsDashboard } from "./columns";

const InvoiceDashboardAdminTermList = (user) => {
    const { invoiceData, loading } = useInvoiceData();

    if (loading) return <div>Loading...</div>;

    return <InvoiceTable title="Verlopen facturenoverzicht" columns={columnsDashboard} data={invoiceData} defaultLimit={10} user={user} />;
};

export default InvoiceDashboardAdminTermList;
